import { render, staticRenderFns } from "./CardColumnList.vue?vue&type=template&id=626ba721"
import script from "./CardColumnList.vue?vue&type=script&lang=js"
export * from "./CardColumnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports